import React from "react";
import EsgDistributionChart from "../EsgDistributionChart";
import styles from "./distribuzioneEsgContainer.module.scss";
import EsgDistributionChartCompare from "./EsgDistributionChartCompare";

type SectionChildrenProps = { reportData: any; reportData2?: any };

const DistribuzioneEsg: React.FC<SectionChildrenProps> = ({
  reportData,
  reportData2,
}) => {
  if (!reportData) {
    return null;
  }

  return (
    <>
      {!reportData2 && (
        <div style={{ marginLeft: 5, marginTop: 16 }}>
          <div className={styles.containerEsgInnerOnePortfolio}>
            <EsgDistributionChart data={reportData.distribuzione_esg} />
          </div>
          <div style={{ marginTop: 16 }}></div>
        </div>
      )}
      {reportData2 && (
        <div style={{ marginLeft: 5, marginTop: 16 }}>
          <div className={styles.containerEsgInnerTwoPortfolio}>
            <EsgDistributionChartCompare
              data={reportData.distribuzione_esg}
              data2={reportData2.distribuzione_esg}
            />
          </div>
          <div style={{ marginTop: 16 }}></div>
        </div>
      )}
    </>
  );
};

export default React.memo(
  DistribuzioneEsg,
  (prevProps: SectionChildrenProps, nextProps: SectionChildrenProps) => {
    return prevProps.reportData === nextProps.reportData;
  },
);
